import React from 'react';
import DepartmentManager from '../../components/admin/department-manager';
import TeamManager from '../../components/admin/team-manager';
import WorkCategoryManager from '../../components/admin/gl-code-manager';
import ProjectManagerAssignment from '../../components/admin/project-manager-assignment';
import StrategicGoalsManager from '../../components/admin/strategic-goals-manager';
import CapitalProjectManager from '../../components/reporting/capital-project-manager';

export default function AdminHomepage() {
  return (
    <div style={{ padding: '0 20px' }}>
        <DepartmentManager />
        <hr style={{ margin: '2rem 0', border: 'none', borderTop: '1px solid #eee' }} />
        <TeamManager />
        <hr style={{ margin: '2rem 0', border: 'none', borderTop: '1px solid #eee' }} />
        <ProjectManagerAssignment />
        <hr style={{ margin: '2rem 0', border: 'none', borderTop: '1px solid #eee' }} />
        <WorkCategoryManager />
        <hr style={{ margin: '2rem 0', border: 'none', borderTop: '1px solid #eee' }} />
        <StrategicGoalsManager />
        <hr style={{ margin: '2rem 0', border: 'none', borderTop: '1px solid #eee' }} />
        <CapitalProjectManager />
    </div>
  );
}
